/* eslint-disable @nx/enforce-module-boundaries */
import { hasAccess } from '@sweetspot/sweetspot-js/features/userAccess/utils/utils'
import { ACCESS_KEYS } from '@sweetspot/sweetspot-js/features/userAccess/constants/accessTable'
import { TFunction } from 'i18next'
import DateHelpers from '@sweetspot/club-portal-legacy/helpers/DateHelpers'
import GetTranslatedString from '@sweetspot/club-portal-legacy/helpers/GetTranslatedString'
import { Voucher } from '@sweetspot/shared/types'
import { VoucherTableItem } from './types'

export const formatVouchers = (
  vouchers: Voucher[],
  t: TFunction,
  language: string,
  roleValue?: string
): VoucherTableItem[] => {
  const filteredVouchers = hasAccess(ACCESS_KEYS.PAGES.VOUCHERS.CREATE, roleValue)
    ? vouchers
    : vouchers.filter((item) => item.code_type === 'unique')

  return filteredVouchers.map((item) => ({
    id: item.id.toString(),
    name: item.name,
    durationType: setPeriodType(item.dynamic_period, t, language),
    validFrom: item.starts_at ? item.starts_at.substring(0, 10) : '',
    validTo: item.ends_at ? item.ends_at.substring(0, 10) : t('vouchers.label_NoEnd'),
    voucherType: setVoucherType(item.code_type, t),
    status: {
      text: t(item.status === 'canceled' ? 'words.invalidated' : `words.${item.status}`),
      state: item.status === 'active' ? 'active' : 'inActive',
      variant:
        item.status === 'active'
          ? 'success-filled'
          : item.status === 'draft'
          ? 'inverted'
          : 'danger-filled',
    },
    createdAt: DateHelpers.dateStringwithMinutes(item.created_at),
  }))
}

const setVoucherType = (voucherType: string, t: TFunction): string => {
  if (voucherType === 'global') return t('vouchers.label_StandaloneCode')
  if (voucherType === 'unique') return t('vouchers.label_BulkCodes')
  return ''
}

const setPeriodType = (dynamicPeriod: any, t: TFunction, language: string): string => {
  if (dynamicPeriod?.period_type === 'dynamic_period')
    return `${GetTranslatedString(language, 'vouchers.label_Dynamic_type')} - ${
      dynamicPeriod.duration_number
    } ${GetTranslatedString(language, 'vouchers.option_' + dynamicPeriod.duration_type)}`

  if (dynamicPeriod?.period_type === 'period') return t('vouchers.label_Period')
  return '-'
}
